var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./SkeletonSubmit.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a516c31c\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SkeletonSubmit.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Skeleton/SkeletonSubmit/SkeletonSubmit.vue.html
// module id = S8bO
// module chunks = 2